import React, { useState } from "react";
import styles from "./index.module.css";
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Hidden,
  ListItemIcon,
} from "@material-ui/core";
import Sidebar from "./sidebar";
import { Route, Link, BrowserRouter as Router, Switch } from "react-router-dom";
import Attainment_Level_Target from "./Attainment_Level_Target";
import Ise_Mse_Data_Import from "./Ise_Mse_Data_Import";
import Ese_Data_Import from "./Ese_Data_Import";
import Co_Attainment from "./Co_Attainment";
import Course_Co_Attainment from "./Cousre_Co_Attainment";
import Course_Attainment_Comparison from "./Course_Attainment_Comparison";
import Po_Attainment from "./Po_Attainment";
import Program_Level_Course from "./Program_level_Course";
import Cay_Po_Attainment from "./Cay_Po_Attainment";
import Individual_Po_Attainment from "./Individual_Po_Attainment";
import Data_Analysis from "./Data_Analysis";
import Student_Co_Attainment from "./Student_Co_Attainment";
import Student_Po_Attainment from "./Student_Po_Attainment";
import Student_Improvement_Plan from "./Student_Improvement_Plan";

const Index = () => {
  console.log("hello")
  return (
    <Router>
      <Grid container>
        <Hidden mdDown>
          <Grid item lg={3} className={styles.sidebarWrapper}>
            <Sidebar />
          </Grid>
        </Hidden>
        <Grid item lg={9}>
          <Switch>
            <Route
              exact
              path="/attainment"
              component={Ise_Mse_Data_Import}
            />
            <Route
              exact
              path="/attainment/ise-mse-data-import/"
              component={Ise_Mse_Data_Import}
            />
            <Route
              exact
              path="/attainment/ese-data-import"
              component={Ese_Data_Import}
            />
            <Route
              exact
              path="/attainment/co-attainment"
              component={Co_Attainment}
            />
            <Route
              exact
              path="/attainment/course-co-attainment"
              component={Course_Co_Attainment}
            />
            <Route
              exact
              path="/attainment/course-attainment-comparision"
              component={Course_Attainment_Comparison}
            />
            <Route
              exact
              path="/attainment/po-attainment"
              component={Po_Attainment}
            />
            <Route
              exact
              path="/attainment/program-level-course"
              component={Program_Level_Course}
            />
            <Route
              exact
              path="/attainment/cay-po-attainment"
              component={Cay_Po_Attainment}
            />
            <Route
              exact
              path="/attainment/individual-po-attainment"
              component={Individual_Po_Attainment}
            />
            <Route
              exact
              path="/attainment/data-analysis"
              component={Data_Analysis}
            />
            <Route
              exact
              path="/attainment/student-co-attainment"
              component={Student_Co_Attainment}
            />
            <Route
              exact
              path="/attainment/student-po-attainment"
              component={Student_Po_Attainment}
            />
            <Route
              exact
              path="/attainment/student-improvement-plan"
              component={Student_Improvement_Plan}
            />
          </Switch>
        </Grid>
      </Grid>
    </Router>
  );
};

export default Index;
